module.exports = __webpack_public_path__ + "img/share-like-active.fc6dba0.svg";